import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './styles.css';
import '../../assets/styles/styles.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp as ThumbUpBorder } from '@fortawesome/free-regular-svg-icons';
import { faThumbsDown as ThumbDownBorder } from '@fortawesome/free-regular-svg-icons';
import { faCommentDots as commentsIcon } from '@fortawesome/free-regular-svg-icons';
import Styles from './styles.json';
//import Login from './../../components/login/login';
import { sendVoteInitiative, requestInitiativeVotesComments } from '../../actions/initiativeActions';
import Footer from './../../components/footer/footer';
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import ModalF from './../../components/modalF/modalF';
import Select from "react-select";
import countries from './../../data/country.json';
import cities from './../../data/city.json';

const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: "white",
            color: "black"
        };
    }
};

function InitiativeForm2() {

    const history = useHistory();
    const dispatch = useDispatch();
    const region = useSelector(state => state.initiative.regionClicked);
    const initiative = useSelector(state => state.initiative.initiativeClicked);
    const [program] = useState(initiative.program);
  
    const programValues = Object.values(program);
    const user = useSelector(state => state.user.user);
    const [pathsChecked, svpathsChecked] = useState([]);
    const [isLike, svisLike] = useState(undefined);

    const [selectedPrograms, setSelectedPrograms] = useState([]);

    let sndVote = JSON.parse(localStorage.getItem('sendVote'));
    sndVote = sndVote !== null ? sndVote : false;
    const [sendVote, svsendVote] = useState(sndVote);
    const [comments, svcomments] = useState("");
    const [requestCountVotesComments, svrequestCountVotesComments] = useState(true);
    const [countVotesComments, svcountVotesComments] = useState({
        totalLike: 0,
        totalDislike: 0,
        totalComments: 2,
        comments: []
    });
    const [tratamientoDatos, setTratamientoDatos] = useState(false);
    const [edad, setEdad] = useState('');
    const [nombre,setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [genero, setGenero] = useState('');
    const [grupoPoblacional, setGrupoPoblacional] = useState('');
    const [urbanoRural, setUrbanoRural] = useState('');
    const [showComments, svshowComments] = useState(false);
    const [country, svcountry] = useState({ "code": "169", "label": "COLOMBIA" });
    const [city, svcity] = useState({
        code: "",
        label: "",
        municipality: "",
    });
    const [allCitiesChecked, svallCitiesChecked] = useState(false);
    const listagrupo = [
        { value: 'COMUNAL', label: 'COMUNAL' },
        { value: 'GITANO', label: 'GITANO o Rrom' },
        { value: 'HABITANTE_DE_CALLE', label: 'HABITANTE DE CALLE O EN SITUACIÓN DE CALLE' },
        { value: 'INDIGENA', label: 'INDIGENA' },
        { value: 'JEFE_DE_HOGAR_MONOPARENTAL', label: 'JEFE DE HOGAR MONOPARENTAL' },
        { value: 'LGTBIQ', label: 'LGTBIQ+' },
        { value: 'MIGRANTE', label: 'MIGRANTE' },
        { value: 'NEGRO_AFRODESCENDIENTE', label: 'NEGRO, AFRODESCENDIENTE, AFROCOLOMBIANO' },
        { value: 'PALENQUERO', label: 'PALENQUERO' },
        { value: 'PERSONAS_CON_DISCAPACIDAD', label: 'PERSONAS CON DISCAPACIDAD' },
        { value: 'RAIZAL', label: 'RAIZAL' },
        { value: 'REINCORPORADO', label: 'REINCORPORADO' },
        { value: 'SECTOR_INTERRELIGIOSO', label: 'SECTOR INTERRELIGIOSO' },
        { value: 'VICTIMAS', label: 'VICTIMAS' },
      ];

      const listagenero = [
        { value: 'Masculino', label: 'Masculino' },
        { value: 'Femenino', label: 'Femenino' },
        { value: 'Otro', label: 'Otro' },
       
      ];
      const listazona = [
        { value: 'Urbano', label: 'Urbano' },
        { value: 'Rural', label: 'Rural' },
    
       
      ];

    const defineStyles = (name) => {
        switch (name) {
            case "bt-like":
                return Styles[isLike === true ? "bt-like-clicked" : "unset"]
            case "bt-like-icon":
                return Styles[isLike === true ? "bt-like-icon" : "unset"]
            case "bt-like-text":
                return Styles[isLike === true ? "bt-like-text" : "unset"]
            case "bt-dislike":
                return Styles[isLike === false ? "bt-dislike-clicked" : "unset"]
            case "bt-dislike-icon":
                return Styles[isLike === false ? "bt-dislike-icon" : "unset"]
            case "bt-dislike-text":
                return Styles[isLike === false ? "bt-dislike-text" : "unset"]
            default:
                return {};
        }
    }

    const handleChangeBox = (event, path) => {
        let tempPaths = [...pathsChecked];
        let find = false;
        pathsChecked.forEach((item, index) => {
            if (item.id === path.id) {
                find = true;
                tempPaths.splice(index, 1);
            }
        });
        if (find === false) tempPaths.push(path);
        //event.target.children[0].checked = !find;
        if (tempPaths.length !== region.paths.length) {
            svallCitiesChecked(false);
        } else if (tempPaths.length === region.paths.length) {
            svallCitiesChecked(true);
        }
        svpathsChecked(tempPaths);
    }

    const validateform = () => {
        if (isLike === undefined) {
            Swal.fire({
                title: "Error",
                confirmButtonColor: "#0f8238b8",
                text: "Debe seleccionar si le gusta o no el programa para realizar la votación.",
                type: "error",
                heightAuto: false
            });
            return false;
        }

        if (selectedPrograms === '') {
            Swal.fire({
                title: "Error",
                confirmButtonColor: "#0f8238b8",
                text: "Debe seleccionar un programa.",
                type: "error",
                heightAuto: false
            });
            return false;
        }
        if (nombre === '' || email === '' ||edad === '' || genero==='' || urbanoRural==='' ) {
            Swal.fire({
                title: "Error",
                confirmButtonColor: "#0f8238b8",
                text: "Debe llenar todos los campos.",
                type: "error",
                heightAuto: false
            });
            return false;
        }
        
        if (tratamientoDatos === false) {
            Swal.fire({
                title: "Error",
                confirmButtonColor: "#0f8238b8",
                text: "Debe aceptar la politica de datos personales.",
                type: "error",
                heightAuto: false
            });
            return false;
        }

        return true;
    }

    const cbVote = (result) => {
        if (result === "success") {
            history.push("/iniciativa/");
        }
    }

    const cbRequestVotesComments = (data) => {
        svcountVotesComments(data);
    }

    const getDeviceInfo = () => {

        let deviceType = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i) === null ? "desktop" : "mobile";
        let systemOperative = "";
        let systemVersion = "";
        let deviceReference = "";
        const deviceData = navigator.userAgent.split("(")[1].split(")")[0].split(";");
        if (deviceType === "mobile") {
            if (navigator.userAgent.includes("Android")) {
                systemOperative = "Android";
                systemVersion = deviceData[1].split(" ")[2];
                deviceReference = deviceData[2].trim();
            }
        } else if (deviceType === "desktop") {
            if (navigator.userAgent.includes("Windows")) {
                systemOperative = "Windows";
            } else if (navigator.userAgent.includes("Linux")) {
                systemOperative = "Linux";
            } else if (navigator.userAgent.includes("Macintosh")) {
                systemOperative = "Macintosh";
            }
        }

        return {
            so: systemOperative,
            version: systemVersion,
            reference: deviceReference,
            type: deviceType
        }
    }

    useEffect(() => {

        if (requestCountVotesComments === true) {
            svrequestCountVotesComments(false);
            let dat = {
                idInitiative: initiative._id
            }
            //dispatch(requestInitiativeVotesComments(dat, cbRequestVotesComments));
        }

        if (sendVote === true) {
            console.log(user);
            svsendVote(false);
            localStorage.setItem('sendVote', JSON.stringify(false));
            if (validateform()) {
                let cities = pathsChecked.map((path) => {
                    return path.name
                })
                let deviceInfo = getDeviceInfo();
                let data = {
                    idUser: '',
                    idInitiative: initiative._id,
                    affectedCities: cities,
                    name: nombre,
                    email: email,
                    comments: comments.replace(/ /g, '').length > 0 ? comments : null,
                    like: isLike,
                    device: deviceInfo,
                    idMicroRegion: region.id.toString(),
                    country,
                    cities: city,
                    programs: selectedPrograms,
                    edad: edad,
                    grupoPoblacional: grupoPoblacional,
                    genero: genero,
                    zona: urbanoRural,
                    tratamientoDatos: tratamientoDatos

                }
                dispatch(sendVoteInitiative(data, cbVote));
            }
        }
    })

    const formatNumberThousand = (number = "", char = ".") => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, char);
    }

    const renderComment = () => {
        return (
            <div className="row m-0 w-100 justify-content-around">
                {
                    countVotesComments.comments.map((item, index) => {
                        return (
                            <div key={index} className="rounded shadow p-2 m-2" style={{ minWidth: 350, minHeight: 100, flex: 1 }}>
                                <div>{`#${index + 1}. ${item.comments}`}</div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    const returnButton = () => {
        if (history.location.search === "?mode=select") {
            history.push("/iniciativa/formulario1/");
        } else {
            history.goBack();
        }
    }

    const handleChangeAllCities = (event) => {
        if (allCitiesChecked) {
            svallCitiesChecked(false);
            svpathsChecked([]);
        } else {
            svallCitiesChecked(true);
            svpathsChecked(region.paths);
        }
    }
    // const toggleProgramSelection = (programValue) => {
    //     if (selectedPrograms.includes(programValue)) {
    //       // Si ya está seleccionado, quítalo de la lista de seleccionados
    //       setSelectedPrograms(selectedPrograms.filter(program => program !== programValue));
    //     } else {
    //       // Si no está seleccionado, agrégalo a la lista de seleccionados
    //       setSelectedPrograms([...selectedPrograms, programValue]);
    //     }
    //   };

    const toggleProgramSelection = (programValue) => {
        setSelectedPrograms([programValue]);
    };
    const styles = {
        row: {
            marginTop: "15px",
            display: 'flex',
            flexWrap: "wrap"
            // justifyContent: 'space-between',
        },
        column: {
            flex: 1,
            margin: '0 10px', // Espaciado entre columnas
        },
        inputContainer: {
            marginBottom: '15px', // Espaciado entre inputs
            display: 'flex',
            flexDirection: 'column',
        },
        label: {
            fontFamily: "sans-serif",
            marginBottom: '5px', // Espaciado entre label e input
        },
    };
    return (
        <React.Fragment>
            {
                showComments && <ModalF onBackgroundPress={() => svshowComments(false)} contentComponent={renderComment} />
            }
            <div className="p-2">
                {/*JSON.stringify(getDeviceInfo())*/}
                {
                    // (sendVote && user === null) && <Login onBackgroundPress={() => {
                     
                    //     svsendVote(false);
                    //     localStorage.setItem('sendVote', JSON.stringify(false));
                    // }} 
                    
                    // />
                }
                <div className="row m-0">
                    <div onClick={() => returnButton()} className="bt-1">Regresar</div>
                </div>
                <div className="row m-0 justify-content-center mt-3">
                    <div className="p-3 rounded shadow col-12" style={{ maxWidth: 600 }}>
                        <div className="initiative-title">Línea Estratégica</div>
                        <div style={{ textAlign: "justify" }}>{` ${initiative.description}`}</div>
                        <div className="row m-0 justify-content-center mt-3">
                            <div className="you-like-text">Programas</div>
                            {


                                // programValues.map((programValue, index) => (
                                //   <div key={index} className="p-3  col-12" style={{ maxWidth: 600 }}>
                                //     {/* Resto de tu código */}
                                //     <input
                                //       type="checkbox"
                                //       checked={selectedPrograms.includes(programValue)}
                                //       onChange={() => toggleProgramSelection(programValue)}
                                //     />
                                //     {` ${programValue}`}
                                //     {/* Resto de tu código */}
                                //   </div>
                                // ))

                                programValues.map((programValue, index) => (
                                    <div key={index} className="p-3  col-12" style={{ maxWidth: 600 }}>
                                        {/* Resto de tu código */}
                                        <input
                                            type="radio"
                                            checked={selectedPrograms[0] === programValue}
                                            onChange={() => toggleProgramSelection(programValue)}
                                        />
                                        {` ${programValue}`}
                                        {/* Resto de tu código */}
                                    </div>
                                ))

                            }
                        </div>

                        <div className="you-like-text">¿Te gusta?</div>
                        <div className="row m-0 justify-content-around">
                            <div className="bt-like bm-3 mt-3" style={defineStyles("bt-like")} onClick={() => svisLike(true)}>
                                <FontAwesomeIcon style={defineStyles("bt-like-icon")} className="bt-like-icon" icon={ThumbUpBorder} />
                                <div className="bt-like-text" style={{ marginTop: 5, ...defineStyles("bt-like-text") }}>{formatNumberThousand(countVotesComments.totalLike)}</div>
                                <div style={defineStyles("bt-like-text")} className="bt-like-text">Me gusta</div>
                            </div>
                            <div className="bt-dislike m-3" style={defineStyles("bt-dislike")} onClick={() => svisLike(false)}>
                                <FontAwesomeIcon style={defineStyles("bt-dislike-icon")} className="bt-like-icon" icon={ThumbDownBorder} />
                                <div className="bt-like-text" style={{ marginTop: 5, ...defineStyles("bt-dislike-text") }}>{formatNumberThousand(countVotesComments.totalDislike)}</div>
                                <div style={defineStyles("bt-dislike-text")} className="bt-like-text">No me gusta</div>
                            </div>
                        </div>
                        <div style={styles.inputContainer}>
                                            <label style={styles.label}>Nombre</label>
                                            <input
                                                styles={colourStyles}
                                                type="text"
                                                value={nombre}
                                                onChange={(e) => setNombre(e.target.value)}
                                            />
                                        </div>

                                        <div style={styles.inputContainer}>
                                            <label style={styles.label}>Correo</label>
                                            <input
                                                styles={colourStyles}
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>

                        {/* <div className="you-like-text">¿Desde dónde votas?</div> */}
                        <Select placeholder="País..." options={countries} value={country} onChange={(value) => svcountry({ code: value.code, name: value.label })} styles={colourStyles} />
                        <div style={{ height: 10 }}></div>
                        {
                            country.code === "169" &&
                            <Select placeholder="Ciudad..." options={cities} onChange={(value) => svcity({ code: value.code, name: value.label, municipality: value.municipality })} styles={colourStyles} />
                        }
                          <div style={{ height: 10 }}></div>
        <div style={styles.inputContainer}>
                                            <label style={styles.label}>Edad</label>
                                            <input
                                                styles={colourStyles}
                                                type="number"
                                                value={edad}
                                                onChange={(e) => setEdad(e.target.value)}
                                            />
                                        </div>
                                        <div style={{ height: 10 }}></div>
                                        <div style={styles.inputContainer}>
                                    <label style={styles.label}>Género</label>
                                    <Select styles={colourStyles}  placeholder="Seleccione una opción"  options={listagenero} onChange={(e) => setGenero(e.value)}/>
                                  
                                </div>
                                <div style={{ height: 10 }}></div>
                                <div style={styles.inputContainer}>
                                    <label style={styles.label}>Grupo Poblacional (si pertenece)</label>
                                    <Select
                                    options={listagrupo}
                                    isSearchable
                                    placeholder="Seleccione una opción"
                                    onChange={(e) => setGrupoPoblacional(e.value)}
                                    />
                                                                      
                                </div>
                                <div style={{ height: 10 }}></div>
                                
                                <div style={styles.inputContainer}>
                                    <label style={styles.label}>Zona</label>
                                    <Select styles={colourStyles}   placeholder="Seleccione una opción" options={listazona}  onChange={(e) => setUrbanoRural(e.value)}
                                   
                                    />
                                </div>

                                            <label style={styles.label}>Indíquenos qué propuesta o temática considera que deben incluirse.</label>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <textarea maxLength={500} rows="4" value={comments} onChange={(event) => svcomments(event.currentTarget.value)}></textarea>


                            <div className="row m-0 align-items-center">
                                {/*<FontAwesomeIcon style={defineStyles("bt-dislike-icon")} className="bt-like-icon" icon={commentsIcon}/>*/}
                                <div>{`${formatNumberThousand(countVotesComments.totalComments)} Personas han dejado su opinión.`}</div>
                            </div>
                            <div onClick={() => svshowComments(true)} className="bt-1 mt-3 mb-1" style={{ width: 200, fontSize: 18, alignSelf: "center" }}>Leer Opiniones</div>
                        </div>
                        <div style={{ height: 10 }}></div>
                        <div style={{ height: 10 }}></div>
                        <div style={{ height: 10, textAlign: "center" }} >

                            <div >  <a href="https://www.valledelcauca.gov.co/loader.php?lServicio=Tools2&lTipo=viewpdf&id=62965" target='_blank'>
                                Acepto el tratamiento de datos
                            </a>

                            </div>


                            <input
                                type="checkbox"
                                checked={tratamientoDatos}
                                onChange={() => setTratamientoDatos(!tratamientoDatos)}
                            />
                        </div>

                        <div style={{ height: 10 }}></div>
                        <div style={{ height: 10 }}></div>
                        <div style={{ height: 10 }}></div>
                        {/* <div className="you-like-text" style={{fontSize:20}}>¿Cuáles municipios cree usted que serán los más beneficiados?</div>
                        <div className="row m-0 justify-content-center">
                            {
                                // region.paths.map(path => (
                                //     <div key={path.id} className="row m-1 bt-checkbox shadow rounded" onClick={(event) => handleChangeBox(event, path)}>
                                //         <input checked={pathsChecked.includes(path)} type="checkbox" className="bt-checkbox-input"/>
                                //         <div style={{pointerEvents:"none", userSelect:"none"}}>{path.name}</div>
                                //     </div>
                                // ))
                            }
                            <div className="row m-1 bt-checkbox shadow rounded" onClick={(event) => handleChangeAllCities(event)}>
                                <input checked={allCitiesChecked} type="checkbox" className="bt-checkbox-input"/>
                                <div style={{pointerEvents:"none", userSelect:"none"}}>Todos</div>
                            </div>
                        </div> */}
                        <div className="row mt-3 m-0 justify-content-center">
                            <div className="bt-1" style={{ fontSize: 20 }} onClick={() => {
                                console.log('votar');
                                svsendVote(true);
                                localStorage.setItem('sendVote', JSON.stringify(true));
                            }}>Participar</div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    )
}

export default InitiativeForm2;